import * as React from "react";
import Text from "src/components/text/Text";
import localeService from "src/dataServices/LocaleService";

const TechnologySolutionsBanner = () => {
  return (
    <section>
    </section>
  );
};

export default TechnologySolutionsBanner;
